import {
  BodyText,
  CaptionText,
  Card,
  LockIcon,
  Radio,
} from '@paypalcorp/pp-react'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useContext, useEffect, useState } from 'react'
import { toCommaSeparatedNumber } from '../__utils__'
import { OfferContext } from './offerContext'

type Props = {
  loanTermLable: string
  loanTermValue: string
  handleSelection: (...args: any[]) => any
  loanAmount: number
  loanLimit: number
  isSelected: boolean
  ind: number
}

const TermInputRadio: React.FC<Props> = ({
  loanTermLable,
  loanTermValue,
  handleSelection,
  loanAmount,
  loanLimit,
  isSelected,
  ind,
}) => {
  const { disableContinue, offerMinAmount } = useContext(OfferContext)

  const [isEnabled, setIsEnabled] = useState(loanAmount <= loanLimit)

  useEffect(() => {
    setIsEnabled(loanAmount >= offerMinAmount && loanAmount <= loanLimit)
    if (isSelected) disableContinue(!isEnabled)
  }, [
    isSelected,
    isEnabled,
    loanAmount,
    loanLimit,
    disableContinue,
    offerMinAmount,
  ])

  return (
    <div className="radioCardContainer">
      <Card
        className={`radioCardWrapper ${
          isSelected ? 'radioCardBorderSelected' : 'radioCardBorderUnselected'
        }`}
      >
        {isEnabled ? (
          <Radio
            type="radio"
            id={`offer-radio-${ind}`}
            name="selectedOffer"
            value={loanTermValue}
            onChange={handleSelection}
            checked={isSelected}
            className="radioButton"
            label={
              <div id={`offer-term-card-${loanTermValue}`}>
                {isSelected ? (
                  <BodyText strong>{loanTermLable}</BodyText>
                ) : (
                  <BodyText>{loanTermLable}</BodyText>
                )}
              </div>
            }
          />
        ) : (
          <div className="disbledRadioButton">
            <LockIcon
              className="lockIcon"
              size="sm"
              color="sysColorBackgroundMediumContrast"
            />
            <div className="lockText">
              <BodyText>{loanTermLable}</BodyText>
              <CaptionText className="lockCaption">
                {interpolate(
                  getLocalizedText('offer-page.termInputRadio.radioLockedText'),
                  {
                    limitAmount: '$' + toCommaSeparatedNumber(loanLimit),
                  },
                )}
              </CaptionText>
            </div>
          </div>
        )}
      </Card>
    </div>
  )
}

export default TermInputRadio
